angular.module("vgresiduos").controller("DialogsPageCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `disposal/${$stateParams.id}/dialogs-page`, [
				{ key: "dialog", value: $stateParams.dialog },
				{ key: "transporter", value: $stateParams.transporter }
			]);
		};
	}
]);
